import React from 'react';
import PropTypes from 'prop-types';

import EdgeIcon from '../icons/BrowserIcons/EdgeIcon';
import ChromiumIcon from '../icons/BrowserIcons/ChromiumIcon';
import SafariIcon from '../icons/BrowserIcons/SafariIcon';
import ChromeIcon from '../icons/BrowserIcons/ChromeIcon';
import FirefoxIcon from '../icons/BrowserIcons/FirefoxIcon';
import SamsungIcon from '../icons/BrowserIcons/SamsungIcon';
import OperaIcon from '../icons/BrowserIcons/OperaIcon';

export const supportedBrowsers = [
  'edge',
  'ie',
  'chrome',
  'firefox',
  'opera',
  'ios',
  'safari',
  'samsung',
];

const propTypes = {
  browser: PropTypes.oneOf(supportedBrowsers),
};

const BrowserIcon = ({ browser, ...props }) => {
  switch (browser) {
    case 'edge':
    case 'ie':
      return <EdgeIcon {...props} />;
    case 'chrome':
      return <ChromeIcon {...props} />;
    case 'firefox':
      return <FirefoxIcon {...props} />;
    case 'opera':
      return <OperaIcon {...props} />;
    case 'safari':
      return <SafariIcon {...props} />;
    case 'samsung':
      return <SamsungIcon {...props} />;
    case 'ios':
      return <SafariIcon {...props} />;
    default: {
      // iOS Chrome browser name
      if (browser.includes('crios')) {
        return <ChromeIcon {...props} />;
      }

      // Safari may appear as just 'Ios'.
      if (browser.includes('safari') || browser.includes('ios')) {
        // cover mobile safari:
        return <SafariIcon {...props} />;
      }

      return <ChromiumIcon {...props} />;
    }
  }
};

BrowserIcon.propTypes = propTypes;

export default BrowserIcon;
